var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./ConfigAccessRulesForm.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-7a780d4e\",\"hasScoped\":false}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./ConfigAccessRulesForm.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/ConfigAccessRulesForm.vue
// module id = 1396
// module chunks = 4